
import { BaseComponent, IBaseComponentProps } from "../BaseComponent/BaseComponent";


export interface IDataControlProps extends IBaseComponentProps
{

}

export abstract class DataControl<TProps extends IDataControlProps = IDataControlProps, TState = {}> extends BaseComponent<TProps, TState>
{
    constructor(props: TProps)
    {
        super(props)
    }

    public abstract setValue(value): void;
    public abstract getValue(): any;
    public abstract focus(): void;

    public getValueRaw()
    {
        throw "DataControl.getRawValue not implemented";
    }
}